import { CurrencyCode } from 'common/api/api-types';

const MAPPING: Record<CurrencyCode, string> = {
  [CurrencyCode.parse('ALL')]: 'Lek',
  [CurrencyCode.parse('AZN')]: '₼',
  [CurrencyCode.parse('CZK')]: 'Kč',
  [CurrencyCode.parse('DKK')]: 'kr.',
  [CurrencyCode.parse('EUR')]: '€',
  [CurrencyCode.parse('GEL')]: 'ლ',
  [CurrencyCode.parse('HUF')]: 'Ft',
  [CurrencyCode.parse('ILS')]: '₪',
  [CurrencyCode.parse('ISK')]: 'kr',
  [CurrencyCode.parse('JPY')]: '¥',
  [CurrencyCode.parse('KZT')]: '₸',
  [CurrencyCode.parse('MKD')]: 'ден',
  [CurrencyCode.parse('NOK')]: 'kr',
  [CurrencyCode.parse('PLN')]: 'zł',
  [CurrencyCode.parse('RSD')]: 'din',
  [CurrencyCode.parse('SEK')]: 'kr',
  // https://wolt.slack.com/archives/C06HWP091GX/p1734673005926299
  [CurrencyCode.parse('UZS')]: '',
};

const currencyCodeToSymbol = (currencyCode?: CurrencyCode) => currencyCode && MAPPING[currencyCode];

export default currencyCodeToSymbol;
